import { useMutation } from "@apollo/client";

import { MapEditorGetAllLayerFeaturesDocument } from "~/modules/mapEditor/api/useMapEditorGetAllLayerFeatures.generated";
import { MapEditorFeatureListRoute_QueryDocument } from "~/modules/mapEditor/routes/MapEditorFeatureListRoute/queries.generated";

import { MapEditorFeatureOtherPanel_FeatureDeleteDocument } from "./mutations.generated";

export function useDeleteOtherFeatureMutation() {
    const [mutate, result] = useMutation(MapEditorFeatureOtherPanel_FeatureDeleteDocument, {
        refetchQueries: [MapEditorFeatureListRoute_QueryDocument, MapEditorGetAllLayerFeaturesDocument],
        awaitRefetchQueries: true,
    });

    const deleteFeature = (featureId: string) =>
        mutate({
            variables: {
                input: {
                    featureId,
                },
            },
        });

    return [deleteFeature, result] as const;
}
